import { APP_URLS } from 'constants/urls';
import { BreadCrumbsOptions } from './types';
import getDashboardHomeItem from './dashboardHomeItem';

export default function getFormChecklistsBreadcrumbMap({
  pathname,
  t,
  entity,
}: BreadCrumbsOptions) {
  const dashboardHomeItem = getDashboardHomeItem({ t });
  const checklistsItem = {
    label: t('forms-checklists-templates'),
    path: APP_URLS.dashboard.formChecklists.index.getPathWithQuery(),
  };

  return [
    {
      condition:
        APP_URLS.dashboard.formChecklists.index.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('forms-checklists-templates'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.formChecklists.add.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        checklistsItem,
        {
          label: t('create-new-checklist'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.formChecklists.edit.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.id}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        checklistsItem,
        {
          label: t('edit-checklist'),
        },
      ],
    },
  ];
}
